// extracted by mini-css-extract-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_bzF","cls2":"ProfilePdfPackCard-cls2__P0 ProfilePdfPackCard-cls1_bzF"};